// 获取直播时间
function getLiveTime(time: any) {
  const date = new Date();
  date.setTime(time * 1000);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const d = date.getDate();
  const h = date.getHours();
  const min = date.getMinutes();
  const s = date.getSeconds();
  const a = year + '-' + month + '-' + d;
  const b = '   ' + h + ':' + min + ':' + s;
  return { a, b };
}
// 获取距离开播时间
function getLiveRunTime(startTime: any) {
  const nowTime = new Date().getTime();
  const date = startTime * 1000;
  let runTime = (date - nowTime) / 1000;
  const differYear = Math.floor(runTime / 86400 / 365);
  runTime = runTime % (86400 * 365);
  const differMonth = Math.floor(runTime / 86400 / 30);
  runTime = runTime % (86400 * 30);
  const day = Math.floor(runTime / 86400);
  runTime = runTime % 86400;
  const hour = Math.floor(runTime / 3600);
  runTime = runTime % 3600;
  const minute = Math.floor(runTime / 60);
  runTime = runTime % 60;
  const second = Math.floor(runTime);
  // console.log(differYear, differMonth, day, hour, minute, second);
  return { differYear, differMonth, day, hour, minute, second };
}
export { getLiveTime, getLiveRunTime };
